export function userRole (role, ml) {
  const roleTypes = {
    1: ml.get('MANAGER'),
    2: ml.get('AUTHORIZED'),
    3: ml.get('USER')
  }
  return roleTypes[role]
}

export function capitalize (value) {
  return value.charAt(0).toLocaleUpperCase('tr-TR') + value.slice(1)
}

export function activityType (type, ml) {
  const activityTypes = {
    1: ml.get('CALL'),
    2: ml.get('APPOINTMENT'),
    3: ml.get('TASK'),
    4: ml.get('E_MAIL')
  }
  return activityTypes[type]
}

export function activityTypeIcon (type) {
  const activityTypeIcons = {
    1: 'icon-solid-telefon',
    2: 'icon-solid-ucakkalkis',
    3: 'icon-solid-gorev',
    4: 'icon-solid-email'
  }
  return activityTypeIcons[type]
}

export function nicename (contact) {
  if (contact !== null && contact !== undefined && contact[0] !== undefined) {
    let name = ''
    let surname = ''
    if (contact[0]['n'] !== undefined && contact[0]['n'] !== null) {
      name = contact[0]['n']
    }
    if (contact[0]['sn'] !== undefined && contact[0]['sn'] !== null) {
      surname = contact[0]['sn']
    }
    return name + ' ' + surname
  }
  return ''
}

export function isUndefined (value) {
  if (value === undefined || value === null) return
  return value
}
